'use memo';

import type { PropsWithChildren, ReactNode } from 'react';
import { StatCard, StatCardTitle } from '@/components/Card/StatCard';
import { HStack } from '@/components/Layout';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/cn';

/**
 * 「もっとみる」導線。メンバー概要に倣い mutedGhost ボタンで表示する。
 * ルートごとの型付き Link を `children` に渡して使う。
 */
export function SeeMoreButton({
  children
}: PropsWithChildren) {
  return <Button asChild variant="mutedGhost" size="sm" className="-mr-2">
      {children}
    </Button>;
}
type BentoCardProps = PropsWithChildren<{
  title: string;
  /** ヘッダー右側に置く要素（もっとみるボタンやサブタイトル） */
  headerRight?: ReactNode;
  className?: string;
}>;

/**
 * Overview のタイル1枚分のカードシェル。
 * メンバー概要に倣い共通 StatCard / StatCardTitle を使う（独自シャドー・角丸は持たない）。
 */
export function BentoCard({
  title,
  headerRight,
  className,
  children
}: BentoCardProps) {
  return <StatCard className={cn('flex flex-col', className)}>
      <HStack className="min-h-8 items-center justify-between gap-2">
        <StatCardTitle>{title}</StatCardTitle>
        {headerRight}
      </HStack>
      {children}
    </StatCard>;
}